// ProjectObserver.js

export default class ProjectObserver {
  constructor(options = {}) {
    this.valid = true;
    this.projectList = document.querySelector('.project-list');
    this.projects = [...document.querySelectorAll('.project')];
    this.projectSrcoll = document.querySelector('.project-scroll-wrapper');
    this.mediaItems = document.querySelectorAll('.full-screen-media');
    this.debug = document.querySelector('.debug');

    this.currentActiveProject = null;
    this.currentActiveId = null;
    this.manualOverrideProject = null;
    this.intersectionObserver = null;

    this.autoplay = true;
    this.idleTimer = null;

    this.viewportCenter = this.calcViewPortCenter();
    this.headerHeight = window.innerWidth * 0.22406;
    this.viewportCenter = this.calcViewPortCenter();

    this.videoLoadQueue = new Map();
    this.loadedVideoIDs = new Set();

    this.mouse = { x: 0, y: 0 };
    this.scrollRaf = null;
    this.updateQueued = false;
    this.lastUpdateTime = 0;
    this.updateInterval = 20;

    this.scrollingToSomething = false;

    this.loadingStates = new Map();
    this.errorCounts = new Map();
    this.maxRetries = 3;
    this.imageTimer = null;

    this.connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    this.isSlowConnection = false;
    
    if (this.connection) {
      this.checkConnection();
      this.connection.addEventListener('change', () => this.checkConnection());
    }

    this.fadeConfig = {
      maxFadeUp: window.innerHeight / 4,
      maxFadeDown: window.innerHeight / 1.8,
      ...options.fadeConfig
    };

    this.mediaItems.forEach(media => {
      const video = media.querySelector('video');
      if (video) {
        const id = media.dataset.id;
        this.setupVideoTracking(video, id);
      }
    });

    if (!this.projects.length) {
      this.valid = false;
      return;
    }

    if (!this.manualOverrideProject && this.projects.length > 0 && !this._firstScrollDone) {
      const first = this.projects[0];
      const firstTop = first.offsetTop;
      const offset = firstTop - (window.innerHeight / 2) + (first.offsetHeight / 2);
      const top = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);
      if (top > 3) window.scrollTo(0, offset);
      this._firstScrollDone = true;
    }

    this.bindEvents();
    this.update();
  }

  checkConnection() {
    if (!this.connection) return;
    
    const slowConnections = ['slow-2g', '2g', '3g'];
    this.isSlowConnection = slowConnections.includes(this.connection.effectiveType) || 
                           this.connection.saveData;
    
    // Adjust loading strategy based on connection

    
    if (this.isSlowConnection) {
      this.maxConcurrentLoads = 1;
    } else {
      this.maxConcurrentLoads = 2;
    }
    
    window.dispatchEvent(new CustomEvent('connectionchange', { 
      detail: { slow: this.isSlowConnection } 
    }));

  }

  bindEvents() {
    
    window.addEventListener('scroll', () => this.updateThrottled());

    window.addEventListener('resize', debounce(() => {
      this.fadeConfig.maxFadeUp = window.innerHeight / 4;
      this.fadeConfig.maxFadeDown = window.innerHeight / 1.8;
      this.updateThrottled();
    }, 100));

    if (!document.querySelector('.index')) {
      if (!window.touch) {
        const mouseMoveHandler = (e) => {
          this.handleMouseMove(e);
          this.updateThrottled();
        };
        window.addEventListener('mousemove', mouseMoveHandler);
        window.addEventListener('pointermove', mouseMoveHandler, { passive: true });

        window.addEventListener('mouseout', (e) => {
          if (!e.relatedTarget && !e.toElement) {
            this.manualOverrideProject = null;
            this.updateThrottled();
          }
        });

        document.addEventListener('keydown', (e) => {
          if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
          
          switch(e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              e.preventDefault();
              if (this.currentActiveProject) {
                this.scrollToNextSibling(this.currentActiveProject);
              }
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              e.preventDefault();
              if (this.currentActiveProject) {
                const prev = this.currentActiveProject.previousElementSibling;
                if (prev) this.scrollToProject(prev);
              }
              break;
          }
        });

      }
    }


  }

  updateThrottled() {
    const now = performance.now();
    if (this.updateQueued) return;
    const timeSinceLast = now - this.lastUpdateTime;
    if (timeSinceLast >= this.updateInterval) {
      this.lastUpdateTime = now;
      this.update();
    } else {
      this.updateQueued = true;
      setTimeout(() => {
        this.updateQueued = false;
        this.lastUpdateTime = performance.now();
        this.update();
      }, this.updateInterval - timeSinceLast);
    }
  }

  


 setupVideoTracking(video, id) {

  let lastTime = 0;



  video.addEventListener('timeupdate', () => {
    
    if (!video.duration) return;

      const activeProject = document.querySelector('.project.active');
      const activeId = activeProject?.querySelector('article')?.dataset?.id;
    
      if (activeId !== id){
        video.pause();
        video.currentTime = 0;
      } 


    const current = video.currentTime;


    if (current < lastTime) {

      const activeProject = document.querySelector(`.project.active`);
      const clipSpan = activeProject?.querySelector('.text-clip');

      if (clipSpan) {
        // Instantly reset clip path with no animation
        clipSpan.style.transition = 'none';
        clipSpan.style.clipPath = 'inset(0 100% 0 0)';
        clipSpan.offsetHeight; // force reflow
        clipSpan.style.transition = 'clip-path 0.4s ease';
      }

    
    }

    lastTime = current;

 
    if (activeId === id) {
      const clipSpan = activeProject.querySelector('.text-clip');

      if (clipSpan) {
        const percent = current / video.duration;
        const remaining = 1 - percent;
        clipSpan.style.clipPath = `inset(0 ${ (remaining * 100).toFixed(2) }% 0 0)`;
      }

    }

  });

  video.addEventListener('ended', () => {

    const activeProject = document.querySelector('.project.active');
    if (!activeProject) return;
    const activeId = activeProject?.querySelector('article')?.dataset?.id;
    if (activeId !== id) return;

    if (this.manualOverrideProject) {
      video.play();
    }else{
      if(window.playmode||this.autoplay){
        this.scrollToNextSibling(this.currentActiveProject);
      }else{
        video.play();
      }
    }

   

  });

  video.addEventListener('canplay', () => {
    video.classList.add('loaded');

  });

  // video.addEventListener('canplaythrough', () => {
  //   video.classList.add('loaded');
  // });

  // video.addEventListener('canplaythrough', () => {
  //   video.classList.add('loaded');
  //   const nextId = this.getNextProject(id);
  //   if (nextId) this.lazyLoadVideo(nextId); // <- chain preload
  // });

}




  handleMouseMove(e) {

    this.autoplay = false;
    if (this.idleTimer) clearTimeout(this.idleTimer);
    
    this.idleTimer = setTimeout(() => {
      this.autoplay = true;
    }, 2500);

    this.mouse.x = e.clientX;
    this.mouse.y = e.clientY;

    const el = document.elementFromPoint(e.clientX, e.clientY);
    const project = el?.closest('.project');

    let hidden = false;
    
    if(project){
      const rect = project.getBoundingClientRect();
      const projectCenter = rect.top + rect.height / 2;
      const distance = Math.round(this.viewportCenter - projectCenter);
      if(distance > 100){
        hidden = true;
      }
    }

    if (project && this.projects.includes(project) && !hidden ) {

      if (this.manualOverrideProject !== project) {
        
        this.manualOverrideProject = project;
        const id = project.querySelector('article')?.dataset?.id;

        if(id){
          this.activateMedia(id);
          this.setActiveProject(project);
        }

        this.update();

        const text = project.querySelector('h3');
        if (text) text.style.opacity = 1;

      }

    } else {
      if (this.manualOverrideProject) {
        this.manualOverrideProject = null;
        this.refreshActiveProject();
        this.update();
      }
    }
  }

activateMedia(id) {
  // Clear existing timer if any
  if (this.imageTimer) {
    clearInterval(this.imageTimer);
    this.imageTimer = null;
  }


  let foundVideo = false;

  this.mediaItems.forEach(media => {
    const isActive = media.dataset.id === id;
    media.classList.toggle('active', isActive);

    const video = media.querySelector('video');
    const img = media.querySelector('img');

    if (isActive && video) {
      foundVideo = true;
      this.updateVideoLoadQueue(id);

      if (!isVideoPlaying(video)) {
        video.currentTime = 0;
        tryPlay(video);
      }
    } else if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });

  // Handle image-only scenario
  if (!foundVideo) {
    const activeProject = document.querySelector(`.project.active`);
    if (!activeProject) return;

    const clipSpan = activeProject.querySelector('.text-clip');

    if (clipSpan) {
      const duration = 5000; // Prescribed time for image in milliseconds
      const interval = 50;   // Update every 50ms for smooth animation
      let elapsed = 0;

      clipSpan.style.transition = 'none';
      clipSpan.style.clipPath = 'inset(0 100% 0 0)';
      clipSpan.offsetHeight; // force reflow for transition reset
      clipSpan.style.transition = `clip-path ${interval}ms linear`;

      this.imageTimer = setInterval(() => {
        elapsed += interval;
        const progress = Math.min(elapsed / duration, 1);
        const remaining = 0.90 - progress;

        clipSpan.style.clipPath = `inset(0 ${(remaining * 100).toFixed(2)}% 0 0)`;

        if (progress >= 1) {
          clearInterval(this.imageTimer);
          this.imageTimer = null;

          if (window.playmode || this.autoplay) {
            this.scrollToNextSibling(activeProject);
          }
        }
      }, interval);
    }
  }
}

  loadVideo(video, src, id) {
    return new Promise((resolve) => {
      const img = video.parentElement?.querySelector('img');
      
      // Set mobile-friendly attributes
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.muted = true;
      video.playsInline = true;
      
      // Only preload metadata initially
      video.preload = 'metadata';
      
      const handleCanPlay = () => {
        video.classList.add('loaded');
        
        if (img) {
          img.style.display = 'none';
        }
        video.style.display = 'block';
        
        // Reset error count on success
        this.errorCounts.delete(id);
        
        // If this is the active video, upgrade to auto preload
        if (id === this.currentActiveId) {
          video.preload = 'auto';
        }
        
        resolve();
      };
      
      const handleError = () => {
        this.handleVideoError(video, src, id, img);
        resolve(); // Resolve anyway to not block queue
      };
      
      video.addEventListener('canplay', handleCanPlay, { once: true });
      video.addEventListener('error', handleError, { once: true });
      
      // Load the video
      video.src = src;
      video.load();
      
      // Timeout fallback
      setTimeout(() => {
        video.removeEventListener('canplay', handleCanPlay);
        video.removeEventListener('error', handleError);
        resolve();
      }, 30000); // 30 second timeout
    });
  }

  handleVideoError(video, src, id, img) {
    const errorCount = (this.errorCounts.get(id) || 0) + 1;
    this.errorCounts.set(id, errorCount);
    
    console.error(`Video load error (${errorCount}/${this.maxRetries}):`, src);
    
    if (errorCount < this.maxRetries) {
      // Retry with exponential backoff
      setTimeout(() => {
        video.src = '';
        video.load();
        setTimeout(() => {
          video.src = src;
          video.load();
        }, 100);
      }, Math.pow(2, errorCount) * 1000);
    } else {
      // Max retries reached, show fallback image
      this.setLoadingState(id, false);
      if (img) {
        img.style.display = 'block';
        video.style.display = 'none';
      }
      
      // Mark as loaded to prevent further attempts
      this.loadedVideoIDs.add(id);
    }
  }


  updateVideoLoadQueue(activeId, video) {

    const isPortrait = window.innerHeight > window.innerWidth;
    const idsToLoad = new Set();


    // Get ordered list of all IDs
   const allIds = this.projects
    .map(p => p.querySelector('article')?.dataset?.id)
    .filter(Boolean);

    const activeIndex = allIds.indexOf(activeId);
    if (activeIndex === -1) return;

    // Always load active
    idsToLoad.add(allIds[activeIndex]);
    for (let offset = 1; offset <= 2; offset++) {
      if (allIds[activeIndex + offset]) idsToLoad.add(allIds[activeIndex + offset]);
    }

    // Go through all media elements
    this.mediaItems.forEach(media => {

      const id = media.dataset.id;
      const video = media.querySelector('video');
      const img = media.querySelector('img');
      const loaded = !media.classList.contains('loaded');

    
      if (!video || !id || !loaded) return;

      const srcToUse = isPortrait && video.dataset.mobsrc ? video.dataset.mobsrc : video.dataset.src;
      if (idsToLoad.has(id)) {

      if(img.dataset.src){
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }

      if (!this.loadedVideoIDs.has(id) && srcToUse && !video.src) {
          
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.muted = true;
          video.playsInline = true;
        
          // video.src = srcToUse;


          this.loadVideo(video, srcToUse, id)
          // console.log(video);


          // this.loadedVideoIDs.add(id);
          // video.style.display = 'block';

          // if (img) img.style.display = 'none';
          // video.play();
        }
      }
      
    });

    //  this.projects.forEach(project => {

    //   const media = project.querySelector('article');

    //   const id = media.dataset.id;
    //   const video = media.querySelector('video');
    //   const img = media.querySelector('img');
    //   const loaded = !media.classList.contains('loaded');

    //   if (!video || !id || !loaded) return;

    //   const srcToUse = isPortrait && video.dataset.mobsrc ? video.dataset.mobsrc : video.dataset.src;

    //   if (idsToLoad.has(id)) {

    //      if (!this.loadedVideoIDs.has(id) && srcToUse && !video.src) {
    //       video.src = srcToUse;
    //       this.loadedVideoIDs.add(id);
    //       video.style.display = 'block';
    //       if (img) img.style.display = 'none';
    //     }
    //   }

    // });

    
}

 setActiveProject(project) {
  if (project !== this.currentActiveProject) {

    if (this.imageTimer) {
      clearInterval(this.imageTimer);
      this.imageTimer = null;
    }

    if (this.currentActiveProject) {
      this.currentActiveProject.classList.remove('active');
      const oldClip = this.currentActiveProject.querySelector('.text-clip');
      if (oldClip) oldClip.style.clipPath = 'inset(0 100% 0 0)';
    }

    if (project) {
      project.classList.add('active');
    }
    
    this.currentActiveProject = project;
  }
}

refreshActiveProject() {
  this.viewportCenter = this.calcViewPortCenter();
 
  let closestProject = null;
  let closestDistance = Infinity;

  this.projects.forEach(project => {
    const rect = project.getBoundingClientRect();
    const projectCenter = rect.top + rect.height / 2;
    const distance = Math.abs(this.viewportCenter - projectCenter);

    if (distance < closestDistance) {
      closestDistance = distance;
      closestProject = project;
    }
  });

  if (closestProject) {
    const id = closestProject.querySelector('article')?.dataset?.id;
    this.setActiveProject(closestProject);
    this.activateMedia(id);
    this.currentActiveId = id;
    
  }
}

  calcViewPortCenter(){

    const scrollY = window.scrollY || window.pageYOffset;
    this.headerHeight = window.innerWidth * 0.22406;

    if(window.innerWidth < 700 && !document.querySelector('.index')){
      this.headerHeight = (window.innerHeight/2.5);
    }

    let obs = Math.max(0, 200 - scrollY/1.6);
    let tempOff = this.headerHeight + obs;
    if (tempOff < this.headerHeight) {
      tempOff = this.headerHeight;
    }

    return Math.round(tempOff);

  }

  update() {

  
    this.viewportCenter = this.calcViewPortCenter();

    this.fadeConfig.maxFadeUp =  140;
    this.fadeConfig.maxFadeDown =  window.innerHeight - (this.viewportCenter - 40);

    // if(this.debug){
    //   this.debug.style.top = `${this.viewportCenter}px`;
    // }

    const isOverride = Boolean(this.manualOverrideProject);
    const focusY = isOverride ? this.mouse.y : this.viewportCenter;
    const opacityPos = this.viewportCenter;
     
    let closestProject = null;
    let closestDistance = Infinity;

    let first = false;

    this.projects.forEach(project => {

   
      const rect = project.getBoundingClientRect();
      const projectCenter = rect.top + rect.height / 2;
      const rawDistance = this.viewportCenter - projectCenter;
      const distance = Math.abs(rawDistance);

      const text = project.querySelector('h3');
      const media = project.querySelectorAll('img, video');

      const activDist = Math.abs(focusY - projectCenter);
      

      // Use different fade curves depending on scroll direction
      let maxFadeDistance = rawDistance < 0
        ? this.fadeConfig.maxFadeDown
        : this.fadeConfig.maxFadeUp;

      
     

      const opacity = 1 - Math.min(distance / maxFadeDistance, 1);

     
      if(this.manualOverrideProject){

        if (project !== this.manualOverrideProject) {
          
   
             text.style.opacity = opacity.toFixed(2)/10;    

              for (let a = 0; a < media.length; a++) {
                const elm = media[a];
                elm.style.opacity = (opacity + 0.1).toFixed(2);
              }

        }else{

          text.style.opacity = 1;
          for (let a = 0; a < media.length; a++) {
            const elm = media[a];
            elm.style.opacity = 1;
          }

        }

      }else{
        
        const passedIt = Math.round(rect.height/2 + (rect.top - this.viewportCenter));
        
        if(this.currentActiveProject === project){

          if(passedIt > 0){
             text.style.opacity = Math.max((opacity + 0.5).toFixed(2), 1);
          }else{
              text.style.opacity = opacity.toFixed(2);
          }

        }else{
           text.style.opacity = opacity.toFixed(2);
        }

          // text.style.opacity = opacity.toFixed(2);
          for (let a = 0; a < media.length; a++) {
            const elm = media[a];
            if(passedIt > 0){
              elm.style.opacity = ((opacity/2) + 0.5).toFixed(2);
            }else{
              elm.style.opacity = ((opacity/2) + 0.5).toFixed(2);
            }


             elm.style.opacity = 1;

            
          }
       
      }

      if (activDist < closestDistance) {
        
        closestDistance = activDist;
        closestProject = project;
      }
      
    });

    if (closestProject) {

      const id = closestProject.querySelector('article')?.dataset?.id;
    
      if (this.manualOverrideProject && closestProject !== this.manualOverrideProject) {
          this.manualOverrideProject = closestProject;
          this.setActiveProject(closestProject);
      }

      if (closestProject !== this.currentActiveProject) {
        this.setActiveProject(closestProject);
      }

      if (id !== this.currentActiveId) {
        this.activateMedia(id);
        this.currentActiveId = id;
      }

    }

  }

  forceUpdate() {
    this.update();
  }

  destroy() {
   window.removeEventListener('scroll', this.update);
   if(!window.touch){
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('pointermove', this.handleMouseMove);
   }
   
    window.removeEventListener('resize', this.handleResize);
    
    if (this.intersectionObserver) {
      if (this.projects?.length) {
        this.projects.forEach(project => this.intersectionObserver.unobserve(project));
      }
      this.intersectionObserver.disconnect();
    }
  }



  scrollToNextSibling(el) {
    if (!el) return;
    
    const next = el.nextElementSibling;
    if (!next) return;
    
    this.scrollToProject(next);
  }



  scrollToProject(el) {

      window.scrollingToSomething = true;

      const next = el;
     
      if (!next) return;

      const translate = getTranslateY(this.projectSrcoll);

      const nextOffset = next.getBoundingClientRect().top + window.scrollY;
      const nextCenter = nextOffset + next.offsetHeight / 2;

      const headerHeight = this.headerHeight;

      let S = 0;

      const threshold = 320; // from 200 = S / 1.6
      const estimated = (nextCenter - headerHeight - 200) / 0.375;

      if (estimated <= threshold) {
        S = Math.round(estimated);
      } else {
        S = Math.round(nextCenter - headerHeight);
      }

      
       const scrollY = window.scrollY || window.pageYOffset;
  
      window.scrollTo({
        top: S,
        behavior: 'smooth',
      });
      

      setTimeout(function(){
       window.scrollingToSomething = false;
      }, 2000);

  }
}


let lastDist = false;
let newDist = false;


function getTranslateY(element) {
  const style = window.getComputedStyle(element);
  const transform = style.transform || style.webkitTransform || style.mozTransform;

  if (transform && transform !== 'none') {
    const match = transform.match(/matrix.*\((.+)\)/);
    if (match) {
      const values = match[1].split(', ');
      const translateY = parseFloat(values[5]); // 6th value is translateY in matrix(a, b, c, d, e, f)
      return translateY;
    }
  }

  return 0; // No transform applied
}

function debounce(fn, delay = 100) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}


function isVideoPlaying(video) {
  return !!(
    video.currentTime > 0 &&
    !video.paused &&
    !video.ended &&
    video.readyState >= 2
  );
}

function tryPlay(video) {
  if (!(video instanceof HTMLVideoElement)) return;
  video.muted = true;
  if (video.readyState < HTMLMediaElement.HAVE_ENOUGH_DATA) {
    video.addEventListener('canplay', () => {
      video.play().catch(err => console.warn('Play rejected:', err));
    }, { once: true });
  } else {
    video.play().catch(err => console.warn('Play failed:', err));
  }
}
